import { render } from "./g-content-page.vue?vue&type=template&id=3f6d7d5a&ts=true"
import script from "./g-content-page.vue?vue&type=script&lang=tsx"
export * from "./g-content-page.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__